import { Box, Flex } from "grid-styled";
import { useTranslation } from "react-i18next";
import { themeGet } from "styled-system";
import system from "system-components";

import theme from "../../../themes/policystat/theme";

import { ClearableTextInput } from "./TextInput";

import { SearchButton } from "pstat-design-system/shared/Button";
import InlineInputWrapper from "pstat-design-system/InlineInputWrapper";

const SearchInput = system({
  is: ClearableTextInput,
  border: 2,
  borderColor: "nav.90",
  py: 3,
  height: "44px"
}).extend`
  border-right: none;
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
  &:focus {
    border: ${themeGet("borders.2")};
    border-color: ${props => themeGet(`colors.${props.focusBorderColor}`)};
    border-right: none;
  }

  // For mobile devices - set font-size for disabling auto-zoom
  @media (max-width: ${theme.breakpoints[1]}) {
    font-size:16px;
  }
`;

const SearchInlineWrapper = system({
  is: InlineInputWrapper,
  width: 1,
  p: 0
});

const SearchField = ({
  inputRef,
  onSearch,
  placeholder,
  loading,
  useNovaColor,
  ...otherProps
}) => {
  const { t } = useTranslation();
  const documentLabelPlural = "documentLabelPlural";
  return (
    <SearchInlineWrapper>
      <Flex width="100%" alignItems="center">
        <Box flex={1}>
          <SearchInput
            id="search_input"
            placeholder={
              placeholder ||
              t("inputs.searchInput.placeholder", { documentLabelPlural })
            }
            aria-label={t(
              "documentSearch.quickSearch.inputComponent.placeholder"
            )}
            focusBorderColor={
              useNovaColor ? "nova.nova-header-color-secondary" : "primary.0"
            }
            {...otherProps}
            innerRef={inputRef}
          />
        </Box>
        <SearchButton
          id="search_button"
          onClick={onSearch}
          loading={loading}
          buttonStyle={useNovaColor ? "novaSearch" : "primary"}
        />
      </Flex>
    </SearchInlineWrapper>
  );
};

export default SearchField;
